<template>
  <div>
    <ConfirmDialog />
    <Toast position="top-right" />
    <LegalFooterLink v-if="route.page != 'legal'" />
    <LegalPublico v-if="route.page == 'legal'" />
    <MapaViewer v-else-if="route.page == 'map_viewer'" />
    <SalidaPublica v-else-if="route.page == 'salidaPublica'" />
    <SalidaPublicaMayores v-else-if="route.page == 'salidaPublicaMayores'" />
    <InformeConductor v-else-if="route.page == 'informeConductor'" />
    <MonitorSalida v-else-if="route.page == 'monitorSalida'" />
    <AlojamientoPublico v-else-if="route.page == 'alojamientoPublico'" />
    <EstudiosPublico v-else-if="route.page == 'estudiosPublico'" />
    <EstudioAsignacionPublico v-else-if="route.page == 'estudioAsignacionPublico'" />
    <EstudiosDashboardPublico v-else-if="route.page == 'estudiosDashboardPublico'" />
    <RegistroCongregacionPublico v-else-if="route.page == 'registroCongregacion'" />
    <GestionUsuariosPublico v-else-if="route.page == 'gestionUsuarios'" />
    <div v-else>
      <PageStart v-if="!isE2EBypass() && (!userStore.isLoggedIn || !crypto.ready)" />

      <ListaTerritorios v-else-if="route.page == 'print'" :print="true" />
      <div
        v-else
        class="flex"
        :class="{ 'flex-column': !screen.isMobile && menuLayout.layout == 'top' }"
      >
        <div class="menu noprint flex z-2 noprint" v-if="!screen.isMobile && menuLayout.layout == 'lateral'">
          <Menu />
        </div>
        <Sidebar
          v-model:visible="screen.showSidebar"
          role="region"
          v-if="screen.isMobile"
          class="w-12rem menu-left noprint"
        >
          <Menu />
        </Sidebar>

        <div
          class="flex-1 flex flex-column pageall"
          :class="{ 'pageall-flow': !screen.isMobile && menuLayout.layout == 'top' }"
        >
          <div
            v-if="screen.isMobile"
          >
            <Menu type="top" />
          </div>
          <Menu v-if="!screen.isMobile && menuLayout.layout == 'top'" type="top-desktop" />
          <EditorTarjeta v-if="route.page == 'formTerritorio' && !screen.isMobile" />
          <EditorTarjetaXs v-if="route.page == 'formTerritorio' && screen.isMobile" />
          <CrearTerritoriosMasivo v-if="route.page == 'crearTerritorios'" />
          <DownloadTerritorio v-if="route.page == 'downloadTerritorio' || route.page == 'parametros'" />
          <ListaTerritorios v-if="route.page == 'listaTerritorio'" />
          <MapaTerritorios v-if="route.page == 'mapaTerritorios'" />
          <MapaCalor v-if="route.page == 'mapaCalor'" />
          <EstadisticasTerritorio v-if="route.page == 'estadisticas'" />
          <!-- <PuntoEncuentro v-if="route.page == 'puntoEncuentro'" /> -->
          <!-- <RegistroTrabajado v-if="route.page == 'registroTrabajado'" /> -->
          <FormSalidas v-if="route.page == 'salidas'" :isMobile="screen.isMobile" />
          <TarjetaTerritorio v-if="route.page == 'tarjetaTerritorio'" />
          <TerritoriosAsignados v-if="route.page == 'tAsignados'" />
          <Rutas v-if="route.page == 'rutas'" />
          <AdminPanel v-if="route.page == 'adminPanel'" />
          <GruposInvitados v-if="route.page == 'gruposInvitados'" />
          <PlantillasMensaje v-if="route.page == 'plantillasMensaje'" />
          <MetadataEnlaces v-if="route.page == 'metadataEnlaces'" />
          <Alojamientos v-if="route.page == 'alojamientos'" />
          <UserManagement v-if="route.page == 'userManagement'" />
          <EstudiosTerritorio v-if="route.page == 'estudiosTerritorio'" />
          <TransporteTerritorio v-if="route.page == 'transporteTerritorio'" />
          <EnlacesSalidas v-if="route.page == 'enlacesSalidas'" />
          <EnlacesInformes v-if="route.page == 'enlacesInformes'" />
          <EnlacesEstudios v-if="route.page == 'estudiosDashboard'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, watch } from "vue";
import { useToast } from "primevue/usetoast";
import { useNotificationBus } from "@/composables/useNotificationBus";
import { useRouterStore } from "@/store/router";
import MapaViewer from "@/page/MapaViewer.vue";
import EstadisticasTerritorio from "@/page/EstadisticasTerritorio.vue";
import FormSalidas from "@/page/FormSalidas.vue";
import TarjetaTerritorio from "./page/TarjetaTerritorio.vue";
import TerritoriosAsignados from "./page/TerritoriosAsignados.vue";
import Rutas from "./page/rutas/Rutas.vue";
import AdminPanel from "./page/AdminPanel.vue";
import GruposInvitados from "./page/GruposInvitados.vue";
import PlantillasMensaje from "./page/PlantillasMensaje.vue";
import MetadataEnlaces from "./page/MetadataEnlaces.vue";
import Alojamientos from "./page/Alojamientos.vue";
import UserManagement from "./page/UserManagement.vue";
import { useEncryptStore } from "./store/useEncryptStore";
import { useUserStore } from "./store/useUserStore";
import { useMenuConfigStore } from "./store/useMenuConfigStore";
import { useMenuLayoutStore } from "./store/useMenuLayoutStore";
import { usePresenceStore } from "./store/usePresenceStore";
import ConfirmDialog from "primevue/confirmdialog";
import { useScreenSize } from "./composables/useScreenSize";
import { useScreenStore } from "./store/useScreenStore";
import { useStorage } from "./composables/useStorage";
import EditorTarjetaXs from "./page/EditorTarjetaXs.vue";
import CrearTerritoriosMasivo from "./page/CrearTerritoriosMasivo.vue";
import SalidaPublica from "./page/SalidaPublica.vue"
import SalidaPublicaMayores from "./page/SalidaPublicaMayores.vue"
import InformeConductor from "./page/InformeConductor.vue"
import MonitorSalida from "./page/MonitorSalida.vue"
import AlojamientoPublico from "./page/AlojamientoPublico.vue"
import EstudiosPublico from "./page/EstudiosPublico.vue"
import EstudioAsignacionPublico from "./page/EstudioAsignacionPublico.vue"
import EstudiosDashboardPublico from "./page/EstudiosDashboardPublico.vue"
import RegistroCongregacionPublico from "./page/RegistroCongregacionPublico.vue"
import GestionUsuariosPublico from "./page/GestionUsuariosPublico.vue"
import EnlacesSalidas from "./page/EnlacesSalidas.vue";
import EnlacesInformes from "./page/EnlacesInformes.vue";
import EnlacesEstudios from "./page/EnlacesEstudios.vue";
import MapaCalor from "./page/MapaCalor.vue";
import LegalPublico from "./page/LegalPublico.vue";
import LegalFooterLink from "./components/LegalFooterLink.vue";

const isE2EBypass = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("e2e") === "1";
};

useScreenSize();

const screen = useScreenStore();

// Consumir el bus de notificaciones (desde composables fuera de setup)
const toast = useToast();
const { queue, shift } = useNotificationBus();
watch(queue, () => { const n = shift(); if (n) toast.add(n); }, { deep: true });

const route = useRouterStore();
const crypto = useEncryptStore();
const userStore = useUserStore();
const menuConfig = useMenuConfigStore();
const menuLayout = useMenuLayoutStore();
const presenceStore = usePresenceStore();
const storage = useStorage();

// Los superusuarios siempre ven todo el menú (no dependen de una congregación
// propia); el resto carga la config de su congregación al loguearse.
watch(
  () => userStore.isLoggedIn,
  (loggedIn) => {
    if (loggedIn && userStore.hasCongregation && !userStore.isSuperUser) {
      menuConfig.load();
    } else {
      menuConfig.reset();
    }
  },
  { immediate: true }
);

watch(
  () => route.page,
  (page) => {
    if (userStore.hasCongregation) {
      presenceStore.sendPresence(page, null);
    }
  }
);

// Páginas públicas/sin sesión: no dependen de los stores que llena getData().
const PUBLIC_PAGES = new Set(["map_viewer", "salidaPublica", "salidaPublicaMayores", "informeConductor", "monitorSalida", "alojamientoPublico", "estudiosPublico", "estudioAsignacionPublico", "registroCongregacion", "estudiosDashboardPublico", "legal"]);

// La navegación interna no remonta PageStart ni vuelve a llamar getData(), así
// que sin esto las páginas seguían mostrando el snapshot cargado al login/F5.
watch(
  () => route.page,
  (page) => {
    if (!page || PUBLIC_PAGES.has(page)) return;
    if (!userStore.isLoggedIn || !crypto.ready) return;
    storage.refreshData();
  }
);

onMounted(() => {
  if (route.page == "map_viewer") return;
  if (userStore.isLoggedIn && userStore.hasCongregation) {
    presenceStore.connect();
  }
});

onBeforeUnmount(() => {
  if (route.page == "map_viewer") return;
  presenceStore.disconnect();
});
</script>

<style>
/* La fuente del sistema, tokens y reset viven en src/styles/* (importados en main.js) */
#app {
  text-align: center;
}
.menu {
  height: 100vh;
  overflow: auto;
  flex: none;
}

.pageall {
  height: 100vh;
  overflow: auto;
  background: var(--bg-grouped);
}

/* Menú superior (escritorio): la página crece hacia abajo en vez de
   scrollear en un panel de altura fija. */
.pageall.pageall-flow {
  height: auto;
  overflow: visible;
}

@media print {
  /* Aquí irían tus reglas CSS específicas para imprimir */
  .noprint {
    display: none !important;
  }
  .pageall {
    height: auto !important;
    overflow: visible !important;
  }
  .p-paginator-bottom,
  .p-column-filter {
    display: none !important;
  }

  .onlyprint {
    display: block !important;
  }
}

@media screen {
  /* Aquí irían tus reglas CSS específicas para imprimir */
  .onlyprint {
    display: none !important;
  }
}

.menu-left.p-sidebar .p-sidebar-content {
  padding: 0 !important;
}
.menu-left.p-sidebar .p-sidebar-header {
  padding: var(--space-2) var(--space-2) 0 !important;
  background: var(--bg-secondary);
}
.menu-left.p-sidebar .p-sidebar-header .p-sidebar-close,
.p-sidebar .p-sidebar-header .p-sidebar-icon {
  color: var(--label-secondary);
}
</style>
